import React, { useEffect, useState } from "react";
import { createImageFromInitials, getInitials } from "../../AgentLogo";
import Avatar from "../../static/images/avata.svg";
import CloseConfirmationDialog from "./chatElements/closeConfirmationDialog";

export default function ServiceChatHeader({ agentName, showModal, messageCounter, botName, miniMize, closeChat, roomClosed, source, sendMessage, productId, ticketRatingDone , clearRoomData}) {
  const [loader,setLoader] = useState(false)
  const [CloseConfirmation, setCloseConfirmation] = useState(false);
  const CallBackMsg = JSON.stringify({
    "title": "Request a Call Back",
    "type": "CustRequestCallBack"
  })
  const confirmationAction = async (val) => {
    if (val) {
      setLoader(true);
      await closeChat();
      setLoader(false);
      // showModal();
    }
    setCloseConfirmation(false);
  }
  useEffect(() => {
    setCloseConfirmation(false)
  }, [roomClosed])
  const handleCloseClick = () => {
    if (ticketRatingDone) {
      window.parent.postMessage({ message: 'Box minimize.', minimize: true ,  closeChat: true }, '*');
    }
  }
  const handleCloseClickAfterRoomClose = () => {
    clearRoomData();
    if (window && window.parent) {
      window.parent.postMessage({ message: 'Box minimize.', minimize: true, closeChat: true }, '*');
    }
    if (window.parent?.ReactNativeWebView) {
      window.parent.ReactNativeWebView.postMessage('close_webview');
    }
     if (window?.ReactNativeWebView) {
        window?.ReactNativeWebView.postMessage('close_webview');
    }

  }
  return (
    <>
      <div className="mini">
        <header >
          {/* {source === 'myacc' ?
            null :
            <span onClick={() => miniMize()} class="minimize"></span>
          } */}
          {/* {!agentName && productId && !roomClosed && botName?
            <span onClick={() => sendMessage({ content: CallBackMsg, type: "json" })} class="callback-icon"></span>
            : null} */}
          <span onClick={() => miniMize()} class="minimize"></span>
          {!roomClosed ? <span onClick={() => {
            setCloseConfirmation(true);
            handleCloseClick();
          }} class="close"></span> : <span onClick={() => {
            handleCloseClickAfterRoomClose();
          }} class="close"></span>}
          <div class="heading-with-icon">
            {/* {agentName ?
              <div className="chaticon initial"  >
                {getInitials(agentName)}
                </div>
              : */}
            <img className="chaticon" src={Avatar} />
            {/* } */}

            <div class="titlewrap">

              <div class="title">PB Chat {messageCounter > 0 ? messageCounter : null}</div>

              <div class="subtitle"></div>
            </div>
          </div>
        </header>
      </div>
      {CloseConfirmation && !ticketRatingDone ?
        <CloseConfirmationDialog confirmationAction={confirmationAction} loader={loader} />
        : ""}
    </>
  );
}
